<ng-container [formGroup]="formGroup">
  <mat-form-field class="login-wrap__text">
    <mat-label>{{ 'pages.restaurantAccount.adVastTagUrl' | translate }}</mat-label>
    <input matInput appFormInputTrim formControlName="vastTagUrl">
    <mat-error *ngIf="formGroup.get('vastTagUrl')?.errors?.pattern && formGroup.get('vastTagUrl')?.touched">
      {{ 'pages.restaurantAccount.urlValidation' | translate }}
    </mat-error>
  </mat-form-field>
</ng-container>
